var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurvebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 264,
    viewBox: "0 0 411 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.85 0.000106812L-14.9995 0.000106812V263.972L410.85 0.000106812Z",
    fill: "#920202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M345.84 0L-14.9987 0V263.972L345.84 0Z",
    fill: "#AC0101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.32 0.000137329L-15.0005 0.000137329V263.972L265.32 0.000137329Z",
    fill: "#C10000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvebg);
export default __webpack_public_path__ + "static/media/curvebg.8b88728c687e6243cc09d5795a9b69e7.svg";
export { ForwardRef as ReactComponent };